import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userSlice.js'
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    REGISTER,
    PURGE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
    key: "OizomGPT",
    version: 2,
    storage,
};

const persistedReducer = persistReducer(persistConfig, userReducer)

export const store = configureStore({
    reducer: {
        oizomGptUser: persistedReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
})

export let persistor = persistStore(store)